module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTc2OCA2NGEzMiAzMiAwIDAgMSAzMS44IDI4LjNMODAwIDk2djEyOGgxMjhhMzIgMzIgMCAwIDEgMy43IDYzLjhMOTI4IDI4OGgtMTI4djQ0OGE2NCA2NCAwIDAgMS02NCA2NGwtNDQ4LTBMMjg4IDkyOGEzMiAzMiAwIDAgMS02My44IDMuN0wyMjQgOTI4bC0wLTEyOEw5NiA4MDBhMzIgMzIgMCAwIDEtMy43LTYzLjhMOTYgNzM2bDEyOC0wTDIyNCAyODhhNjQgNjQgMCAwIDEgNjQtNjRoNDQ4Vjk2YTMyIDMyIDAgMCAxIDMyLTMyek0yODggMjg4bC0wIDQ0OEw3MzYgNzM2VjI4OEgyODh6IiBmaWxsPSIjMCIgcC1pZD0iMTYyMSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Crop-outlined.svg
// module id = +7yp
// module chunks = 75